// 9fbef606107a605d69c0edbcd8029e5d
export const brand = {
  TCP: 'tcp',
  GYMBOREE: 'gymboree',
  SNJ: 'snj',
  PJP: 'pjp',
};

export const sites = {
  us: {
    countryCode: 'US',
    currencyCode: 'USD',
  },
  ca: {
    countryCode: 'CA',
    currencyCode: 'CAD',
  },
};

export const keyboard = {
  KEY_ENTER: 13,
  KEY_SPACE: 32,
  KEY_ESCAPE: 27,
  KEY_UP: 38,
  KEY_DOWN: 40,
  KEY_HOME_KEY: 36,
  KEY_END_KEY: 35,
};

export const filterParams = {
  FILTER_CATAGORY: 'categoryPath2_uFilter',
  FILTER_COLOR: 'TCPColor_uFilter',
  FILTER_SIZE: 'v_tcpsize_uFilter',
  FILTER_PRICE_RANGE: 'unbxd_price_range_uFilter',
  FILTER_FIT: 'v_tcpfit_unbxd_uFilter',
  FILTER_GENDER: 'gender_uFilter',
  FILTER_AGE: 'age_group_uFilter',
};

export const clearAll = {
  CLEAR_ALL_SEARCH_FILTER: 'CLEAR_ALL_SEARCH_FILTER',
  CLEAR_ALL_PLP_FILTER: 'CLEAR_ALL_PLP_FILTER',
};

export const defaultDeviceType = 'desktop';

const PREVIEW_RES_HEADER_KEY = 'x-akamai-staging';
const PREVIEW_REQ_HEADER_KEY = 'is_preview';

// List for static pages that will not be rendered at server side
const staticPagesWithOwnTemplate = [
  'mystyleplace',
  'international-stores',
  'showLabels',
  'transform-promo-combination',
  'image-co-picker',
  'shoppable-hotspots-test',
];

export const deviceTiers = { LOW: 1, MEDIUM: 2, HIGH: 3 };

const brandsArray = ['childrensplace', 'gymboree', 'sugarandjade', 'pjplace'];

const brandsToCookie = {
  gymboree: 'GYM',
  childrensplace: 'TCP',
  sugarandjade: 'SNJ',
};

export default {
  brand,
  defaultDeviceType,
  PREVIEW_RES_HEADER_KEY,
  PREVIEW_REQ_HEADER_KEY,
  sites,
  keyboard,
  staticPagesWithOwnTemplate,
  deviceTiers,
  brandsArray,
  brandsToCookie,
};
